export const hasValidationErrors = (list = []) =>
  list.some((item) => Number(item.flag) === 1);

export const getRowErrorMessage = (row) => {
  if (row?.errorMessage) return row.errorMessage;
  if (row?.errorMsgs?.length) return row.errorMsgs.join(", ");
  return "";
};

/**
 * Normalize validate API response — backends may return either
 * `data.recordList` or a plain array on `data`.
 */
export const normalizeValidatedList = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload.recordList)) return payload.recordList;
  if (Array.isArray(payload)) return payload;
  return [];
};
